const CREATE_CERTIFICATE = 'CREATE_CERTIFICATE'
const CREATE_CERTIFICATE_SUCCESS = 'CREATE_CERTIFICATE_SUCCESS'
const CREATE_CERTIFICATE_ERROR = 'CREATE_CERTIFICATE_ERROR'

const GET_CERTIFICATE = 'GET_CERTIFICATE'
const GET_CERTIFICATE_SUCCESS = 'GET_CERTIFICATE_SUCCESS'
const GET_CERTIFICATE_ERROR = 'GET_CERTIFICATE_ERROR'

const PATCH_CERTIFICATE = 'PATCH_CERTIFICATE'
const PATCH_CERTIFICATE_SUCCESS = 'PATCH_CERTIFICATE_SUCCESS'
const PATCH_CERTIFICATE_ERROR = 'PATCH_CERTIFICATE_ERROR'

const GET_CERTIFICATE_LIST = 'GET_CERTIFICATE_LIST'
const GET_CERTIFICATE_LIST_SUCCESS = 'GET_CERTIFICATE_LIST_SUCCESS'
const GET_CERTIFICATE_LIST_ERROR = 'GET_CERTIFICATE_LIST_ERROR'

const GET_CERTIFICATE_PAYMENT_SETTING = 'GET_CERTIFICATE_PAYMENT_SETTING'
const GET_CERTIFICATE_PAYMENT_SETTING_SUCCESS =
  'GET_CERTIFICATE_PAYMENT_SETTING_SUCCESS'
const GET_CERTIFICATE_PAYMENT_SETTING_ERROR =
  'GET_CERTIFICATE_PAYMENT_SETTING_ERROR'

const PATCH_CERTIFICATE_PAYMENT_SETTING = 'PATCH_CERTIFICATE_PAYMENT_SETTING'
const PATCH_CERTIFICATE_PAYMENT_SETTING_SUCCESS =
  'PATCH_CERTIFICATE_PAYMENT_SETTING_SUCCESS'
const PATCH_CERTIFICATE_PAYMENT_SETTING_ERROR =
  'PATCH_CERTIFICATE_PAYMENT_SETTING_ERROR'

const PATCH_CERTIFICATE_PRICE = 'PATCH_CERTIFICATE_PRICE'
const PATCH_CERTIFICATE_PRICE_SUCCESS = 'PATCH_CERTIFICATE_PRICE_SUCCESS'
const PATCH_CERTIFICATE_PRICE_ERROR = 'PATCH_CERTIFICATE_PRICE_ERROR'

export {
  CREATE_CERTIFICATE,
  CREATE_CERTIFICATE_SUCCESS,
  CREATE_CERTIFICATE_ERROR,
  GET_CERTIFICATE,
  GET_CERTIFICATE_SUCCESS,
  GET_CERTIFICATE_ERROR,
  PATCH_CERTIFICATE,
  PATCH_CERTIFICATE_SUCCESS,
  PATCH_CERTIFICATE_ERROR,
  GET_CERTIFICATE_LIST,
  GET_CERTIFICATE_LIST_SUCCESS,
  GET_CERTIFICATE_LIST_ERROR,
  GET_CERTIFICATE_PAYMENT_SETTING,
  GET_CERTIFICATE_PAYMENT_SETTING_SUCCESS,
  GET_CERTIFICATE_PAYMENT_SETTING_ERROR,
  PATCH_CERTIFICATE_PAYMENT_SETTING,
  PATCH_CERTIFICATE_PAYMENT_SETTING_SUCCESS,
  PATCH_CERTIFICATE_PAYMENT_SETTING_ERROR,
  PATCH_CERTIFICATE_PRICE,
  PATCH_CERTIFICATE_PRICE_SUCCESS,
  PATCH_CERTIFICATE_PRICE_ERROR,
}
